const tgApp = {}

// URLからドメイン部分のみ取り出す関数
tgApp.getDomain = function (url) {
  let domain;
  if (!url) {
    return '';
  }
  if (url.indexOf('://') > -1) {
    domain = url.split('/')[2];
  } else {
    domain = url.split('/')[0];
  }
  domain = domain.split(':')[0];
  domain = domain.split('?')[0];
  return domain;
};



// クエリ版(有料アプリ会員(paidMember)・無料アプリ会員仕分け(unpaidMember))
tgApp.memberQuery = function (query = "user_info", obj_key = "isPremium") {
  function isJSON(sJSON) {
    try {
      JSON.parse(sJSON);
      return true;
    } catch (e) {
      return false;
    }
  }

  // localStorageのデータの取得
  const storageQueryApp = localStorage.getItem('storageQueryApp')
  const storageQueryAppValidDateStr = localStorage.getItem('storageQueryAppValidDate')

  // クエリ取得
  const decodedQuery = decodeURIComponent(window.location.search);
  const searchParams = new URLSearchParams(decodedQuery);

  if (searchParams.has(query)) {
    const usersInfo = decodeURIComponent(searchParams.get(query));

    if (isJSON(usersInfo)) {
      const usersInfoJson = JSON.parse(usersInfo.toString());
      const dtNow = new Date()
      if (usersInfoJson[obj_key] == true) { //trueのときlocalStorageを更新し値を返す
        dtNow.toISOString()
        localStorage.setItem('storageQueryApp', 'paidMember');
        localStorage.setItem('storageQueryAppValidDate', dtNow);
        return 'paidMember';
      } else { //falseのときlocalStorageを更新し値を返す
        dtNow.toISOString()
        localStorage.setItem('storageQueryApp', 'unpaidMember');
        localStorage.setItem('storageQueryAppValidDate', dtNow);
        return 'unpaidMember';
      }
    }
  }

  // localStorageにデータがある場合期限を確認し期限内ならば値を返す、falseならばlocalStorageは更新しない
  if (storageQueryApp) {
    const dtSevendaysAgo = new Date()
    dtSevendaysAgo.setDate(dtSevendaysAgo.getDate() - 7); //有効期限1週間
    const storageQueryAppValidDate = new Date(storageQueryAppValidDateStr);
    if (storageQueryAppValidDate >= dtSevendaysAgo) {
      return storageQueryApp;
    } else {
      localStorage.removeItem('storageQueryApp');
      localStorage.removeItem('storageQueryAppValidDate');
    }
  }

  // 会員でない場合はfalse
  return false;
}



// リファラー版(アプリ会員仕分け)
/*
  - 直前にアプリの認証ページを経由している場合→アプリ会員 localStorageにデータを格納
  - localStorageにデータが格納されている(過去に認証している)→アプリ会員
  - localStorageは期限あり(1週間経つと削除される)
  - localStorageにはreferrerApp(リファラードメイン)・referrerAppValidDate(日付)の2つデータを格納
  - 引数として(shopifyの管理画面から入力可能な)認証ページのURL(shopifyValidReferrerURL)をとる
*/

tgApp.isMemberReferrer = function (shopifyValidReferrerURL,storageKey) {
  if (!shopifyValidReferrerURL) {
    return false
  }
  // localStorageのデータ・リファラーの取得
  const storageReferrerApp = localStorage.getItem('referrerApp-' + storageKey)
  const storageReferrerAppValidDateStr = localStorage.getItem('referrerAppValidDate-' + storageKey)
  const referrerApp = document.referrer;
  const referrerAppDomain = tgApp.getDomain(referrerApp);
  const storageReferrerAppDomain = tgApp.getDomain(storageReferrerApp);

  //複数の引数(ドメイン)に対応
  let shopifyValidReferrerURLArray = [];
  if (Array.isArray(shopifyValidReferrerURL)) {
    shopifyValidReferrerURLArray = shopifyValidReferrerURL
  } else {
    shopifyValidReferrerURLArray.push(shopifyValidReferrerURL);
  }

  const shopifyValidDomainArray = shopifyValidReferrerURLArray.map(item => tgApp.getDomain(item))

  // 候補のうち1つでも有効な認証ページを経由しているか
  const isAppDomainValid = shopifyValidDomainArray.some(item => {
    return referrerAppDomain !== '' && referrerAppDomain === item
  })

  // 候補のうち1つでもlocalStorageに有効なデータがあるか
  const isStorageAppDomainValid = shopifyValidDomainArray.some(item => {
    return storageReferrerAppDomain.indexOf(item) != -1
  })

  // 直前にアプリの認証ページ経由ならばtrue localStorageを更新
  if (isAppDomainValid) {
    const dtNow = new Date()
    dtNow.toISOString()
    localStorage.setItem('referrerApp-' + storageKey, referrerAppDomain);
    localStorage.setItem('referrerAppValidDate-' + storageKey, dtNow);
    return true;
  }
  // localStorageにデータがある場合期限を確認し期限内ならばtrue localStorageは更新しない
  else if (isStorageAppDomainValid) {
    if (storageReferrerAppValidDateStr) {
      const dtLimitDatetime = new Date()
      dtLimitDatetime.setHours(dtLimitDatetime.getHours() - 24); //有効期限24時間
      const storageReferrerAppValidDate = new Date(storageReferrerAppValidDateStr);
      if (storageReferrerAppValidDate >= dtLimitDatetime) {
        return true;
      } else {
        localStorage.removeItem('referrerApp-' + storageKey);
        localStorage.removeItem('referrerAppValidDate-' + storageKey);
        return false;
      }
    }
    return false;
  }
  // アプリ認証されていないユーザーもしくは期限切れのユーザーはfalse
  else {
    return false;
  }
}
